import { DateTime } from 'luxon';
import useInterval from 'beautiful-react-hooks/useInterval';
import useForceUpdate from '../hooks/useForceUpdate';

const Timer: React.FC<{ start: DateTime; end?: DateTime }> = ({ start, end }) => {
    const forceUpdate = useForceUpdate();

    const endDateTime = end || DateTime.now();

    const duration = endDateTime.diff(start);

    useInterval(() => {
        forceUpdate();
    }, 1000);

    return (
        <div>
            <div>{duration.toFormat(`hh':'mm':'ss'`)}</div>
        </div>
    );
};

export default Timer;
